export default {
  name: 'Ad',
  tel: 'Telefon',
  save: 'Kaydet',
  confirm: 'Onayla',
  cancel: 'İptal',
  delete: 'Sil',
  complete: 'Tamamlandı',
  loading: 'Yükleniyor...',
  telEmpty: 'Lütfen telefon numarasını girin!',
  nameEmpty: 'Soyad, Ad',
  nameInvalid: 'Lütfen tam adınızı yazın.',
  confirmDelete: 'Silmek istediğinize emin misiniz?',
  telInvalid: 'Telefon numarası',
  vanCalendar: {
    end: 'Bitiş',
    start: 'Başlangıç',
    title: 'Tarih Seçin',
    confirm: 'Onayla',
    startEnd: 'Başlangıç/Bitiş',
    weekdays: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
    monthTitle: function monthTitle(year, month) {
      return year + " Yıl " + month + " Ay";
    },
    rangePrompt: function rangePrompt(maxRange) {
      return " Seçilen günler " + maxRange + " günü geçemez";
    }
  },
  vanContactCard: {
    addText: 'Kişi Ekle'
  },
  vanPagination: {
    prev: 'Önceki Sayfa',
    next: 'Sonraki Sayfa'
  },
  vanPullRefresh: {
    pulling: 'Yenilemek için aşağı çekin...',
    loosing: 'Yenilemek için bırakın...'
  },
  vanSubmitBar: {
    label: 'Toplam：'
  },
  vanCoupon: {
    unlimited: 'Sınırsız',
    discount: function discount(_discount) {
      return "%" + _discount + " İndirim";
    },
    condition: function condition(_condition) {
      return _condition + " TL üzerinde kullanılabilir";
    }
  },
  vanCouponCell: {
    title: 'Kupon',
    tips: 'Uygun Değil',
    count: function count(_count) {
      return _count + " adet kullanılabilir";
    }
  },
  vanCouponList: {
    empty: 'Kupon yok',
    exchange: 'Değiştir',
    close: 'Kapat',
    enable: 'Kullanılabilir',
    disabled: 'Kullanılamaz',
    placeholder: 'Kupon kodunu girin'
  },
  vanAddressEdit: {
    area: 'Bölge',
    postal: 'Posta Kodu',
    areaEmpty: 'Lütfen seçin',
    addressEmpty: 'Adres',
    postalEmpty: 'Posta kodu hatalı',
    defaultAddress: 'Adres',
    telPlaceholder: 'Alıcının telefon numarası',
    namePlaceholder: 'Ad',
    areaPlaceholder: 'İl / İlçe / Semt'
  },
  vanAddressEditDetail: {
    label: 'Adres',
    placeholder: 'Detaylı adres'
  },
  vanAddressList: {
    add: 'Adres Ekle'
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/tr.js